import { render, staticRenderFns } from "./BrandComponent.vue?vue&type=template&id=9eb7ee30&scoped=true&"
import script from "./BrandComponent.vue?vue&type=script&lang=ts&"
export * from "./BrandComponent.vue?vue&type=script&lang=ts&"
import style0 from "./BrandComponent.vue?vue&type=style&index=0&id=9eb7ee30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9eb7ee30",
  null
  
)

export default component.exports